import { render, staticRenderFns } from "./ServiceFavorate.vue?vue&type=template&id=4dab5c72&scoped=true&"
import script from "./ServiceFavorate.vue?vue&type=script&lang=js&"
export * from "./ServiceFavorate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4dab5c72",
  null
  
)

export default component.exports